export default {
  buttons: {
    title: "Layout"
  }
}
